var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user-details-connection-speed" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "highcharts-light connection-speed-info-container" },
      [
        _vm.hasNoData
          ? _c("div", { staticClass: "no-data-message" }, [
              _vm._v("\n      No Data To Display\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.wifi
          ? _c("div", { staticClass: "connection-speed-info-row" }, [
              _c("div", { staticClass: "connection-speed-icon" }, [
                _c("i", { class: _vm.getIconClass(_vm.wifi.quality) }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "connection-speed-text" }, [
                _vm._v("Wifi"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "connection-speed-value": true,
                    "semantic-bad": _vm.wifi.quality === "bad",
                  },
                },
                [_vm._v(_vm._s(_vm.wifi.val))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.ethernet
          ? _c("div", { staticClass: "connection-speed-info-row" }, [
              _c("div", { staticClass: "connection-speed-icon" }, [
                _c("i", { class: _vm.getIconClass(_vm.ethernet.quality) }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "connection-speed-text" }, [
                _vm._v("Ethernet"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "connection-speed-value": true,
                    "semantic-bad": _vm.ethernet.quality === "bad",
                  },
                },
                [_vm._v(_vm._s(_vm.ethernet.val))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.cell
          ? _c("div", { staticClass: "connection-speed-info-row" }, [
              _c("div", { staticClass: "connection-speed-icon" }, [
                _c("i", { class: _vm.getIconClass(_vm.cell.quality) }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "connection-speed-text" }, [
                _vm._v("Cellular"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "connection-speed-value": true,
                    "semantic-bad": _vm.cell.quality === "bad",
                  },
                },
                [_vm._v(_vm._s(_vm.cell.val))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.vpn
          ? _c("div", { staticClass: "connection-speed-info-row" }, [
              _c("div", { staticClass: "connection-speed-icon" }, [
                _c("i", { class: _vm.getIconClass(_vm.vpn.quality) }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "connection-speed-text" }, [
                _vm._v("VPN"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "connection-speed-value": true,
                    "semantic-bad": _vm.vpn.quality === "bad",
                  },
                },
                [_vm._v(_vm._s(_vm.vpn.val))]
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-title" }, [
      _c("span", [_vm._v("Avg Connection Speed")]),
      _vm._v(" "),
      _c("i", {
        staticClass: "far fa-question-circle",
        attrs: {
          "data-toggle": "tooltip",
          title: "Not all meeting platforms support connection speed",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }